export async function roleRequest(url: string, method: string, roleData: any) {
  try {
    const response = await fetch(url, {
      method,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      credentials: "include",
      body: JSON.stringify(roleData),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(
        errorData?.message?.message ||
          errorData?.message ||
          `HTTP error! Status: ${response.status}`,
      );
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Ошибка при обновлении/создании роли:", error);
    throw error;
  }
}
